module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2"
  }, [(_vm.transportExtrasArray.length > 0) ? _c('div', {
    staticClass: "w-100 darker font-weight-600 mb-4 mt-2 mx-3 fs-large"
  }, [_vm._v("Transport")]) : _vm._e(), _vm._v(" "), (_vm.transportsAlredyBooked.length === 0) ? _c('div', _vm._l((_vm.transportExtrasArray), function(transport, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "pb-4"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between bg-lighter py-1"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "py-1 mx-3 d-flex flex-row justify-content-between"
    }, [_c('div', [_c('p', {
      staticClass: "darker font-weight-600 pl-3 fs-normal"
    }, [_vm._v(_vm._s(transport.component.name) + " - " + _vm._s(transport.componentPrice.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "pl-3 d-flex flex-row align-items-center pb-1"
    }, [_c('div', {
      staticClass: "d-flex flex-column min-size"
    }, [_c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Availability: " + _vm._s(_vm.showAvailability(transport)))]), _vm._v(" "), _c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Price per pax: " + _vm._s(_vm.formatPrice(transport.componentPrice.grossprice)) + " €")]), _vm._v(" "), _c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Total Price: " + _vm._s(_vm.formatPrice(transport.quantityToAdd * transport.componentPrice.value)) + " €")])]), _vm._v(" "), ((transport.quantityAvailable > 0 && transport.quantity > 0) || transport.quantity === 0) ? _c('div', {
      staticClass: "d-flex flex-row ml-5 justify-content-center"
    }, [_c('button', {
      class: [transport.quantityToAdd === 0 ? 'bg-medium' : '', 'btn', 'secondary'],
      on: {
        "click": function($event) {
          return _vm.toggleButton(index, transport, true)
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      class: [transport.quantityToAdd > 0 ? 'bg-medium' : '', 'btn', 'secondary', 'ml-2'],
      on: {
        "click": function($event) {
          return _vm.toggleButton(index, transport, false)
        }
      }
    }, [_vm._v("No")])]) : _c('div', {
      staticClass: "availability-info mx-3 mb-2 font-weight-600"
    }, [_c('p', [_vm._v("No more available seats")])])])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-column justify-content-center mr-3"
    }, [(transport.quantityToAdd !== 0 && transport.quantityToAdd < _vm.calculateTotalPax) ? _c('div', {
      staticClass: "d-flex flex-row align-items-end max-content"
    }, [_c('i', {
      staticClass: "ico ico-alert color-6 mr-0 fs-super"
    }), _vm._v(" "), _c('p', {
      staticClass: "color-6 fs-normal font-weight-600 ml-2"
    }, [_vm._v("Pax without transport: "), _c('span', {
      staticClass: "fs-large font-weight-600"
    }, [_vm._v(_vm._s(_vm.calculateTotalPax - transport.quantityToAdd))])])]) : _vm._e(), _vm._v(" "), (transport.quantityToAdd > 0) ? _c('div', {
      staticClass: "d-flex flex-column align-items-center mt-2 justify-content-center"
    }, [_c('div', {
      staticClass: "d-flex flex-row py-2 justify-content-center size"
    }, [_c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-2 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd('remove', transport)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark fs-smaller m-0"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transport.quantityToAdd),
        expression: "transport.quantityToAdd"
      }],
      staticClass: "text-center fs-larger px-0 bg-lighter darker input-size",
      attrs: {
        "disabled": "",
        "type": "number",
        "placeholder": "0",
        "min": "0"
      },
      domProps: {
        "value": (transport.quantityToAdd)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(transport, "quantityToAdd", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-2 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd('add', transport)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark fs-smaller m-0"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-row"
    }, [_c('div', {
      staticClass: "max-content"
    }, [_c('label', {
      staticClass: "dark font-weight-600 fs-small"
    }, [_vm._v("Total pax with transport: ")]), _vm._v(" "), _c('span', {
      staticClass: "fs-large font-weight-600 ml-1"
    }, [_vm._v(_vm._s(transport.quantityToAdd))])])])]) : _vm._e()])])])])
  }), 0) : _c('div', {
    staticClass: "mx-3 mb-2 font-weight-600"
  }, _vm._l((_vm.transportsAlredyBooked), function(transport, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "pb-4"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between bg-lighter py-1"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "py-1 mx-3 d-flex flex-row justify-content-between"
    }, [_c('div', [_c('p', {
      staticClass: "darker font-weight-600 pl-3 fs-normal"
    }, [_vm._v(_vm._s(transport.component.name) + " - " + _vm._s(transport.componentPrice.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "pl-3 d-flex flex-row align-items-center pb-1 justify-content-between"
    }, [_c('div', {
      staticClass: "d-flex flex-column min-size"
    }, [_c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Total Pax: " + _vm._s(transport.quantity))]), _vm._v(" "), _c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Price per pax: " + _vm._s(_vm.formatPrice(transport.componentPrice.grossprice)) + " €")]), _vm._v(" "), _c('p', {
      staticClass: "dark font-weight-600 pl-3 fs-small"
    }, [_vm._v("Total Price: " + _vm._s(_vm.formatPrice(transport.quantity * transport.componentPrice.value)) + " €")])]), _vm._v(" "), _vm._m(0, true)])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mx-5"
    }, [_c('button', {
      staticClass: "btn secondary avoid-text-breaking",
      on: {
        "click": _vm.changeToEdit
      }
    }, [_vm._v("Edit Transport")])])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "availability-info mx-5 mb-2 font-weight-600"
  }, [_c('p', [_vm._v("Transport already added")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e1b558"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddTransport/AddExtraTransport.vue
// module id = 1779
// module chunks = 0